<template>
  <div id="promotions">
    <TipBox info :title="$t('tips.promo.title_2')">
      <span v-html="$t('tips.promo.description')"></span>
    </TipBox>
    <Datatable
      v-if="inventory"
      entity="promotion"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[{text: 'promotions.new', method: onCreate, condition: function() { return $store.getters.loggedUserHasModifyPermission }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.usage', method: viewUsage},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserHasModifyPermission }}
      ]">
    </Datatable>
    <Modal
      name="delete-confirmation"
      :title="$t('promotions.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: $t('datatable.delete'), action: deletePromotionAction, primary: true}]">
      <p>{{$t('promotions.delete_message')}}?</p>
    </Modal>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";

  export default {

    name: "companyPromotions",

    components: { Datatable },

    data() {
      return {
        inventory: null,
        actionRow: { },
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "promotions.title";
      this.$store.state.pageIcon = "/icon/promos.svg";
      this.inventory = await this.$store.getters.getContextInventory;
    },

    methods: {
      ...mapActions(["deletePromotion"]),
      viewUsage(row) {
        let id = row.id;
        this.$router.push({ path: '/promotions/usage', query : {id: id, branch: this.$route.query.branch, company: this.$route.query.company} });
      },
      edit(id) {
        this.$router.push({ path: '/promotions/edit', query : {id: id, branch: this.$route.query.branch, company: this.$route.query.company} });
      },
      onCreate() {
        this.$router.push({ path: '/promotions/new', query : {branch: this.$route.query.branch, company: this.$route.query.company} });
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id);
      },
      onRowDelete(row) {
        this.actionRow = row;
        this.$modal.show("delete-confirmation");
      },
      async deletePromotionAction(){
        this.$store.commit("showSpinner", true);
        let response = await this.deletePromotion({inventory: this.inventory.id, id: this.actionRow.id });
        if (response) {
          this.$modal.show("delete-confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$modal.show("delete-confirmation", false);
          toast(this.$t("error.no_server"),"error");
          this.$store.commit("showSpinner", false);
        }
      }
    }
  }
</script>
